import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';
import { getPermissions } from '../../utils/getPermissions';
import DeviceUptimeDiagram from './DeviceUptimeDiagram';

export default function DeviceUptimeChart({ auth, device }) {
  if (!device) {
    return null;
  }

  const p = getPermissions(auth);

  if (!p.atLeastTierProOrSuperUser) {
    return null;
  }

  const { heartbeatPercent } = device;

  return (
    <Panel data-test="panel-uptime">
      <Panel.Heading>{`${heartbeatPercent}% Uptime`}</Panel.Heading>
      <Panel.Body>
        <DeviceUptimeDiagram device={device} />
      </Panel.Body>
    </Panel>
  );
}

DeviceUptimeChart.propTypes = {
  auth: PropTypes.object,
  device: PropTypes.object,
};
